import React,{useState,useEffect} from 'react';
import {motion} from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import ThemeToggle from './ThemeToggle';

const {FiMenu,FiX}=FiIcons;

const Header=()=> {
  const [isScrolled,setIsScrolled]=useState(false);
  const [isMobileMenuOpen,setIsMobileMenuOpen]=useState(false);

  useEffect(()=> {
    const handleScroll=()=> {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll',handleScroll);
    return ()=> window.removeEventListener('scroll',handleScroll);
  },[]);

  const scrollToSection=(sectionId)=> {
    const element=document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({behavior: 'smooth'});
      setIsMobileMenuOpen(false);
    }
  };

  const navigateToCourse=()=> {
    window.open('https://swiy.co/hYor','_blank','noopener,noreferrer');
    setIsMobileMenuOpen(false);
  };

  return (
    <motion.header
      className={`fixed w-full z-50 transition-all duration-300 ${
        isScrolled
          ? 'bg-white dark:bg-slate-900 shadow-2xl border-b-4 border-amber-200 dark:border-amber-600'
          : 'bg-transparent'
      }`}
      initial={{y: -100}}
      animate={{y: 0}}
      transition={{duration: 0.5}}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-20">
          <div className="flex-shrink-0">
            <h1 className="text-3xl md:text-4xl font-bold text-slate-800 dark:text-white">
              GenX<span className="text-amber-500">Dojo</span>
            </h1>
          </div>

          <nav className="hidden md:block">
            <div className="ml-10 flex items-baseline space-x-8">
              <button
                onClick={()=> scrollToSection('benefits')}
                className="text-slate-700 dark:text-slate-200 hover:text-amber-600 dark:hover:text-amber-400 px-4 py-3 text-lg font-semibold transition-colors rounded-lg hover:bg-amber-50 dark:hover:bg-amber-900/20"
              >
                Benefits
              </button>
              <button
                onClick={()=> scrollToSection('pricing')}
                className="text-slate-700 dark:text-slate-200 hover:text-amber-600 dark:hover:text-amber-400 px-4 py-3 text-lg font-semibold transition-colors rounded-lg hover:bg-amber-50 dark:hover:bg-amber-900/20"
              >
                Pricing
              </button>
              <button
                onClick={()=> scrollToSection('testimonials')}
                className="text-slate-700 dark:text-slate-200 hover:text-amber-600 dark:hover:text-amber-400 px-4 py-3 text-lg font-semibold transition-colors rounded-lg hover:bg-amber-50 dark:hover:bg-amber-900/20"
              >
                Reviews
              </button>
            </div>
          </nav>

          <div className="hidden md:flex items-center space-x-4">
            <ThemeToggle />
            <button
              onClick={navigateToCourse}
              className="bg-gradient-to-r from-amber-500 to-orange-500 hover:from-amber-600 hover:to-orange-600 text-white px-8 py-4 rounded-xl font-bold text-xl transition-colors duration-200 shadow-lg hover:shadow-xl border-2 border-amber-300"
            >
              Get Started - <span className="relative inline-block">
                <span className="text-red-600 line-through decoration-red-600 decoration-4 text-lg">$250</span>
                <span className="ml-2 font-black bg-gradient-to-r from-green-400 to-emerald-500 bg-clip-text text-transparent text-3xl" style={{fontWeight: 900}}>$65</span>
              </span>
            </button>
          </div>

          <div className="md:hidden flex items-center space-x-2">
            <ThemeToggle />
            <button
              onClick={()=> setIsMobileMenuOpen(!isMobileMenuOpen)}
              className="text-slate-600 dark:text-slate-300 hover:text-slate-800 dark:hover:text-white p-2"
            >
              <SafeIcon icon={isMobileMenuOpen ? FiX : FiMenu} className="h-8 w-8" />
            </button>
          </div>
        </div>

        {isMobileMenuOpen && (
          <motion.div
            className="md:hidden bg-white dark:bg-slate-900 border-t-4 border-amber-200 dark:border-amber-600 shadow-xl"
            initial={{opacity: 0,height: 0}}
            animate={{opacity: 1,height: 'auto'}}
            exit={{opacity: 0,height: 0}}
          >
            <div className="px-4 pt-4 pb-6 space-y-3">
              <button
                onClick={()=> scrollToSection('benefits')}
                className="block w-full text-left px-4 py-3 text-lg font-semibold text-slate-700 dark:text-slate-200 hover:text-amber-600 dark:hover:text-amber-400 rounded-lg hover:bg-amber-50 dark:hover:bg-amber-900/20"
              >
                Benefits
              </button>
              <button
                onClick={()=> scrollToSection('pricing')}
                className="block w-full text-left px-4 py-3 text-lg font-semibold text-slate-700 dark:text-slate-200 hover:text-amber-600 dark:hover:text-amber-400 rounded-lg hover:bg-amber-50 dark:hover:bg-amber-900/20"
              >
                Pricing
              </button>
              <button
                onClick={()=> scrollToSection('testimonials')}
                className="block w-full text-left px-4 py-3 text-lg font-semibold text-slate-700 dark:text-slate-200 hover:text-amber-600 dark:hover:text-amber-400 rounded-lg hover:bg-amber-50 dark:hover:bg-amber-900/20"
              >
                Reviews
              </button>
              <button
                onClick={navigateToCourse}
                className="block w-full text-left bg-gradient-to-r from-amber-500 to-orange-500 hover:from-amber-600 hover:to-orange-600 text-white px-4 py-4 rounded-xl font-bold text-xl mt-4 shadow-lg"
              >
                Get Started - <span className="relative inline-block">
                  <span className="text-red-600 line-through decoration-red-600 decoration-4 text-lg">$250</span>
                  <span className="ml-2 font-black bg-gradient-to-r from-green-400 to-emerald-500 bg-clip-text text-transparent text-2xl" style={{fontWeight: 900}}>$65</span>
                </span>
              </button>
            </div>
          </motion.div>
        )}
      </div>
    </motion.header>
  );
};

export default Header;